import { useFetch } from '#app';
import { asAuthUser, authUserHeaders } from 'r3ui-lib';
import type { AuthApi, AuthUserDto } from '~/types/ports/auth.api';

export const authApi: AuthApi = {
  async fetchCurrentUser(token: string): Promise<AuthUserDto> {
    const { data, error } = await useFetch('/api/services/auth/user', {
      headers: authUserHeaders(token),
    });

    if (error.value) {
      throw error.value;
    }

    const user = asAuthUser<AuthUserDto>(data.value);

    if (!user) {
      throw new Error('fetchCurrentUser: пустой ответ');
    }

    return user;
  },

  async logOutSSO(): Promise<unknown> {
    return $fetch('/api/auth/logout', { method: 'POST' });
  },
};
